(function () {
  if (typeof window === "undefined") return;

  window._ctl_loaded = window._ctl_loaded || {
    ga: false,
    hotjar: false
  };

  function getSettings() {
    return window.CTL_SETTINGS || {};
  }

  function sentryCapture(payload) {
    if (typeof window.stompSentryCapture === "function") {
      window.stompSentryCapture(payload || {});
    }
  }

  function logConsentIssue(code, message, extra) {
    var metadata = extra || {};
    sentryCapture({
      level: "warning",
      message: "[CookieConsent][" + code + "] " + message,
      tags: {
        area: "cookie-consent",
        issue_code: code
      },
      extra: metadata
    });
  }

  function logConsentError(code, error, extra) {
    var metadata = extra || {};
    sentryCapture({
      level: "error",
      message: "[CookieConsent][" + code + "] runtime error",
      error: error,
      tags: {
        area: "cookie-consent",
        error_code: code
      },
      extra: metadata
    });
  }

  function getDomains() {
    var parts = location.hostname.split(".");
    var domains = [];
    var i;

    for (i = 0; i < parts.length; i += 1) {
      var d = parts.slice(i).join(".");
      domains.push(d, "." + d);
    }

    return Array.from(new Set(domains));
  }

  var SHOPIFY_CONSENT_COOKIES = {
    performance: ["_shopify_analytics", "_shopify_s", "_shopify_y","_merchant_analytics"],
    // C0003 Functional — Shopify re-issues these after storefront JS / cart / privacy
    // API hydrate. Keep them blocked until functional consent is granted.
    functional: ["cart_currency", "localization"],
    targeting: ["_shopify_marketing","_merchant_marketing"]
  };

  var TARGETING_COOKIES = [
  "_shopify_marketing",
  "_merchant_marketing",
  "FPAU"
];

  // C0004 Targeting — Klaviyo marketing pixel
  var TARGETING_APP_COOKIES = ["__kla_id"];

  // C0002 Performance — LocalStorage keys (Hotjar)
  var PERFORMANCE_LOCAL_STORAGE_KEYS = [
    "hjActiveViewportIds"
  ];

  var TARGETING_LOCAL_STORAGE_KEYS = [
    "$last_referrer",
    "$referrer",
    "__kl_key",
    "kl-post-identification-sync",
    "klaviyoOnsite"
  ];

  var TARGETING_LOCAL_STORAGE_PREFIXES = ["klaviyo"];

  var FUNCTIONAL_LOCAL_STORAGE_KEYS = [
    "shopify:webmcp_adapter_loaded"
  ];

  var SIGN_IN_WITH_SHOP_PREFIX = "signInWithShop:";

  // C0001 — never remove during consent cleanup.
  var STRICTLY_NECESSARY_LOCAL_STORAGE_KEYS = [
    "signInWithShop:cartSyncTransferCompletedAt"
  ];

  var POST_LOAD_LOCAL_STORAGE_CLEANUP_MS = 2000;
  var postLoadLocalStorageCleanupTimer = null;

  var PERFORMANCE_SESSION_STORAGE_KEYS = [
    "__shopify_agent_context_events",
    "_shs_state",
    "hjViewportId"
  ];

  var GOOGLE_ANALYTIC_COOKIE = ["FPID"];
  var GOOGLE_TARGETING_COOKIE = ["FPAU"];
  var TARGETING_SESSION_STORAGE_KEYS = [
    "klaviyoPagesVisitCountV2"
  ];

  var TARGETING_SESSION_STORAGE_PREFIXES = ["ri-", "wpm-ri-", "klaviyo"];

  // C0001 — never remove during consent cleanup.
  var STRICTLY_NECESSARY_SESSION_STORAGE_KEYS = [
    "consentHeader",
    "isMerchantSession"
  ];

  var POST_LOAD_SESSION_STORAGE_CLEANUP_MS = 2000;
  var postLoadSessionStorageCleanupTimer = null;

  var REJECTED_CONSENT_STATE = {
    performance: false,
    functional: false,
    targeting: false
  };

  // HttpOnly Shopify cookies (_shopify_analytics, _shopify_marketing) can only be
  var customerPrivacyReadyQueue = [];
  var customerPrivacyReadyState = "pending";

  function ensureCustomerPrivacyReady(callback) {
    if (customerPrivacyReadyState === "ready" && window.Shopify && window.Shopify.customerPrivacy) {
      if (typeof callback === "function") callback(true);
      return;
    }

    if (typeof callback === "function") {
      customerPrivacyReadyQueue.push(callback);
    }

    if (customerPrivacyReadyState === "loading") {
      return;
    }

    customerPrivacyReadyState = "loading";

    function finish(success) {
      customerPrivacyReadyState = success ? "ready" : "failed";
      var queue = customerPrivacyReadyQueue.slice();
      customerPrivacyReadyQueue = [];

      queue.forEach(function (cb) {
        cb(success);
      });
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        function (error) {
          if (error) {
            logConsentError("CUSTOMER_PRIVACY_LOAD_FAILED", error);
            finish(false);
            return;
          }

          finish(Boolean(window.Shopify && window.Shopify.customerPrivacy));
        }
      );
      return;
    }

    if (window.Shopify && window.Shopify.customerPrivacy) {
      finish(true);
      return;
    }

    logConsentIssue("CUSTOMER_PRIVACY_UNAVAILABLE", "Shopify Customer Privacy API was not found on page load");
    finish(false);
  }

  function deleteCookie(name) {
    var domains = getDomains();
    var paths = ["/", ""];
    var extras = [
      "",
      " Secure;",
      " SameSite=Lax;",
      " SameSite=Strict;",
      " SameSite=None; Secure;",
      " Secure; SameSite=Lax;"
    ];
    var i;
    var j;
    var k;
    var e;
    var path;
    var extra;
    var expires = "expires=Thu, 01 Jan 1970 00:00:00 UTC; ";

    for (i = 0; i < domains.length; i += 1) {
      for (j = 0; j < paths.length; j += 1) {
        path = paths[j] || "/";
        for (e = 0; e < extras.length; e += 1) {
          extra = extras[e];
          document.cookie = name + "=; " + expires + "path=" + path + "; domain=" + domains[i] + ";" + extra;
        }
      }
    }

    for (k = 0; k < paths.length; k += 1) {
      path = paths[k] || "/";
      for (e = 0; e < extras.length; e += 1) {
        extra = extras[e];
        document.cookie = name + "=; " + expires + "path=" + path + ";" + extra;
      }
    }
  }

  function deleteNamedCookies(names) {
    var list = Array.isArray(names) ? names : [names];
    var i;

    for (i = 0; i < list.length; i += 1) {
      deleteCookie(list[i]);
    }
  }

  // Stomp has no instant.page, so scroll never re-issues cart_currency / localization.
  // Essence prefetches data-instant links while scrolling; block that until C0003.
  function applyInstantPrefetchConsent(functionalOK) {
    var links = document.querySelectorAll("a[data-instant]");
    var i;

    for (i = 0; i < links.length; i += 1) {
      if (functionalOK) {
        delete links[i].dataset.noInstant;
      } else {
        links[i].dataset.noInstant = "";
      }
    }
  }

  var functionalCookieSweepTimer = null;

  function functionalCookiesPresent() {
    return /(?:^|;\s*)(cart_currency|localization)=/.test(document.cookie || "");
  }

  function purgeFunctionalCookiesIfRejected() {
    if (isAllowed("C0003")) return;
    if (!functionalCookiesPresent()) return;
    deleteNamedCookies(SHOPIFY_CONSENT_COOKIES.functional);
  }

  function scheduleFunctionalCookieSweep() {
    if (isAllowed("C0003")) return;
    if (functionalCookieSweepTimer) return;

    functionalCookieSweepTimer = window.setTimeout(function () {
      functionalCookieSweepTimer = null;
      try {
        purgeFunctionalCookiesIfRejected();
      } catch (err) {
        logConsentError("FUNCTIONAL_COOKIE_SWEEP_FAILED", err);
      }
    }, 0);
  }

  function installPrefetchGuard() {
    var originalAppendChild;
    var originalFetch;
    var originalXhrSend;

    if (window.__ctlPrefetchGuard) return;
    window.__ctlPrefetchGuard = true;

    // instant.page uses Node.appendChild on document.head, not Element.appendChild.
    try {
      originalAppendChild = Node.prototype.appendChild;
      Node.prototype.appendChild = function (node) {
        try {
          if (
            node &&
            node.nodeName === "LINK" &&
            String(node.rel || "").toLowerCase() === "prefetch" &&
            !isAllowed("C0003")
          ) {
            return node;
          }
        } catch (err) {
          logConsentError("PREFETCH_GUARD_FAILED", err);
        }

        return originalAppendChild.call(this, node);
      };
    } catch (err) {
      logConsentError("PREFETCH_GUARD_INSTALL_FAILED", err);
    }

    // Essence fetches Shopify sections / recommendations when they enter view.
    // Those responses Set-Cookie cart_currency + localization.
    try {
      if (typeof window.fetch === "function") {
        originalFetch = window.fetch;
        window.fetch = function () {
          var result = originalFetch.apply(this, arguments);
          if (result && typeof result.finally === "function") {
            return result.finally(scheduleFunctionalCookieSweep);
          }
          if (result && typeof result.then === "function") {
            return result.then(
              function (value) {
                scheduleFunctionalCookieSweep();
                return value;
              },
              function (error) {
                scheduleFunctionalCookieSweep();
                throw error;
              }
            );
          }
          return result;
        };
      }
    } catch (err) {
      logConsentError("FETCH_GUARD_INSTALL_FAILED", err);
    }

    try {
      originalXhrSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        this.addEventListener("loadend", scheduleFunctionalCookieSweep);
        return originalXhrSend.apply(this, arguments);
      };
    } catch (err) {
      logConsentError("XHR_GUARD_INSTALL_FAILED", err);
    }

    try {
      if (window.cookieStore && typeof cookieStore.addEventListener === "function") {
        cookieStore.addEventListener("change", function (event) {
          try {
            if (isAllowed("C0003")) return;
            var changed = event && event.changed ? event.changed : [];
            var i;
            for (i = 0; i < changed.length; i += 1) {
              if (SHOPIFY_CONSENT_COOKIES.functional.indexOf(changed[i].name) > -1) {
                scheduleFunctionalCookieSweep();
                return;
              }
            }
          } catch (err) {
            logConsentError("COOKIE_STORE_CHANGE_FAILED", err);
          }
        });
      }
    } catch (err) {
      logConsentError("COOKIE_STORE_LISTEN_FAILED", err);
    }
  }

  function isProtectedLocalStorageKey(key) {
    return STRICTLY_NECESSARY_LOCAL_STORAGE_KEYS.indexOf(key) > -1;
  }

  function deleteLocalStorageKeys(keys) {
    var list = Array.isArray(keys) ? keys : [keys];
    var i;

    try {
      for (i = 0; i < list.length; i += 1) {
        if (isProtectedLocalStorageKey(list[i])) {
          continue;
        }

        localStorage.removeItem(list[i]);
      }
    } catch (err) {
      logConsentError("LOCAL_STORAGE_DELETE_FAILED", err, { keys: list });
    }
  }

  function deleteLocalStorageByPrefixes(prefixes) {
    var list = Array.isArray(prefixes) ? prefixes : [prefixes];
    var keys;
    var i;
    var j;

    try {
      keys = Object.keys(localStorage);
      for (i = 0; i < keys.length; i += 1) {
        if (isProtectedLocalStorageKey(keys[i])) {
          continue;
        }

        for (j = 0; j < list.length; j += 1) {
          if (keys[i].indexOf(String(list[j])) === 0) {
            localStorage.removeItem(keys[i]);
            break;
          }
        }
      }
    } catch (err) {
      logConsentError("LOCAL_STORAGE_PREFIX_DELETE_FAILED", err, { prefixes: list });
    }
  }

  function resolveConsentState(consentState) {
    return {
      performance: consentState && typeof consentState.performance === "boolean"
        ? consentState.performance
        : isAllowed("C0002"),
      functional: consentState && typeof consentState.functional === "boolean"
        ? consentState.functional
        : isAllowed("C0003"),
      targeting: consentState && typeof consentState.targeting === "boolean"
        ? consentState.targeting
        : isAllowed("C0004")
    };
  }

  function deleteNonProtectedSignInWithShopLocalStorage() {
    var keys;
    var i;

    try {
      keys = Object.keys(localStorage);
      for (i = 0; i < keys.length; i += 1) {
        if (keys[i].indexOf(SIGN_IN_WITH_SHOP_PREFIX) !== 0) {
          continue;
        }

        if (isProtectedLocalStorageKey(keys[i])) {
          continue;
        }

        localStorage.removeItem(keys[i]);
      }
    } catch (err) {
      logConsentError("LOCAL_STORAGE_SHOP_PAY_DELETE_FAILED", err);
    }
  }

  // Runs on first page load, every refresh, and every consent change.
  // Deletes keys by name/prefix only when the matching category consent is not granted.
  function applyLocalStorageConsent(consentState) {
    var state = resolveConsentState(consentState || {});

    // C0002 Performance — keep only when performance consent is granted.
    if (!state.performance) {
      deleteLocalStorageKeys(PERFORMANCE_LOCAL_STORAGE_KEYS);
    }

    // C0004 Targeting — keep only when targeting consent is granted.
    if (!state.targeting) {
      deleteLocalStorageKeys(TARGETING_LOCAL_STORAGE_KEYS);
      deleteLocalStorageByPrefixes(TARGETING_LOCAL_STORAGE_PREFIXES);
    }

    // C0003 Functional — keep only when functional consent is granted.
    if (!state.functional) {
      deleteLocalStorageKeys(FUNCTIONAL_LOCAL_STORAGE_KEYS);
    }

    // Non-protected Shop Pay keys are not strictly necessary (C0001 allowlist above).
    if (!state.functional || !state.targeting) {
      deleteNonProtectedSignInWithShopLocalStorage();
    }
  }

  function deleteTargetingLocalStorage(consentState) {
    applyLocalStorageConsent(consentState);
  }

  function schedulePostLoadLocalStorageCleanup(consentState) {
    var state = resolveConsentState(consentState || {});

    if (state.functional && state.targeting && state.performance) {
      if (postLoadLocalStorageCleanupTimer) {
        window.clearTimeout(postLoadLocalStorageCleanupTimer);
        postLoadLocalStorageCleanupTimer = null;
      }
      return;
    }

    if (postLoadLocalStorageCleanupTimer) {
      window.clearTimeout(postLoadLocalStorageCleanupTimer);
    }

    postLoadLocalStorageCleanupTimer = window.setTimeout(function () {
      postLoadLocalStorageCleanupTimer = null;
      applyLocalStorageConsent(consentState);
      applyAppEmbedCookieConsent(consentState);
      deleteShopifyBuiltInCookies(consentState);
    }, POST_LOAD_LOCAL_STORAGE_CLEANUP_MS);
  }

  function isProtectedSessionStorageKey(key) {
    return STRICTLY_NECESSARY_SESSION_STORAGE_KEYS.indexOf(key) > -1;
  }

  function deleteSessionStorageKeys(keys) {
    var list = Array.isArray(keys) ? keys : [keys];
    var i;

    try {
      for (i = 0; i < list.length; i += 1) {
        if (isProtectedSessionStorageKey(list[i])) {
          continue;
        }

        sessionStorage.removeItem(list[i]);
      }
    } catch (err) {
      logConsentError("SESSION_STORAGE_DELETE_FAILED", err, { keys: list });
    }
  }

  function deleteSessionStorageByPrefixes(prefixes) {
    var list = Array.isArray(prefixes) ? prefixes : [prefixes];
    var keys;
    var i;
    var j;

    try {
      keys = Object.keys(sessionStorage);
      for (i = 0; i < keys.length; i += 1) {
        if (isProtectedSessionStorageKey(keys[i])) {
          continue;
        }

        for (j = 0; j < list.length; j += 1) {
          if (keys[i].indexOf(String(list[j])) === 0) {
            sessionStorage.removeItem(keys[i]);
            break;
          }
        }
      }
    } catch (err) {
      logConsentError("SESSION_STORAGE_PREFIX_DELETE_FAILED", err, { prefixes: list });
    }
  }

  // Deletes keys by name/prefix only when the matching category consent is not granted.
  function applySessionStorageConsent(consentState) {
    var state = resolveConsentState(consentState || {});

    // C0002 Performance — keep only when performance consent is granted.
    if (!state.performance) {
      deleteSessionStorageKeys(PERFORMANCE_SESSION_STORAGE_KEYS);
    }

    // C0004 Targeting — keep only when targeting consent is granted.
    if (!state.targeting) {
      deleteSessionStorageKeys(TARGETING_SESSION_STORAGE_KEYS);
      deleteSessionStorageByPrefixes(TARGETING_SESSION_STORAGE_PREFIXES);
    }
  }

  function schedulePostLoadSessionStorageCleanup(consentState) {
    var state = resolveConsentState(consentState || {});

    if (state.performance && state.functional && state.targeting) {
      if (postLoadSessionStorageCleanupTimer) {
        window.clearTimeout(postLoadSessionStorageCleanupTimer);
        postLoadSessionStorageCleanupTimer = null;
      }
      return;
    }

    if (postLoadSessionStorageCleanupTimer) {
      window.clearTimeout(postLoadSessionStorageCleanupTimer);
    }

    postLoadSessionStorageCleanupTimer = window.setTimeout(function () {
      postLoadSessionStorageCleanupTimer = null;
      applySessionStorageConsent(consentState);
      applyAppEmbedCookieConsent(consentState);
      deleteShopifyBuiltInCookies(consentState);
    }, POST_LOAD_SESSION_STORAGE_CLEANUP_MS);
  }

  function deleteCookiesByPrefixes(prefixes) {
    var list = Array.isArray(prefixes) ? prefixes : [prefixes];
    var cookies = document.cookie ? document.cookie.split(";") : [];

    cookies.forEach(function (entry) {
      var name = entry.split("=")[0].trim();
      list.forEach(function (prefix) {
        if (name.toLowerCase().indexOf(String(prefix).toLowerCase()) === 0) {
          deleteCookie(name);
        }
      });
    });
  }

  function getGroups() {
    var match = document.cookie.match(/(?:^|;\s*)OptanonConsent=([^;]+)/);
    if (match) {
      var decoded = decodeURIComponent(match[1]);
      var groupsMatch = decoded.match(/groups=([^&]+)/);
      if (groupsMatch && groupsMatch[1]) {
        return groupsMatch[1];
      }
    }

    if (typeof window.OnetrustActiveGroups === "string" && window.OnetrustActiveGroups.length) {
      return window.OnetrustActiveGroups;
    }

    return "";
  }

  function getConsentSnapshot() {
    return {
      groups: getGroups(),
      performance: isAllowed("C0002"),
      functional: isAllowed("C0003"),
      targeting: isAllowed("C0004")
    };
  }

  function isAllowed(group) {
    var groups = getGroups();
    if (!groups) return false;
    if (groups.indexOf(group + ":1") > -1) return true;

    var normalized = String(groups).replace(/\s+/g, "");
    var wrapped = "," + normalized + ",";
    return wrapped.indexOf("," + group + ",") > -1;
  }

  function isConsentGroupAllowed(group) {
    return isAllowed(group);
  }

  function shopifyConsentValue(value) {
    if (value === true || value === "yes" || value === "1" || value === 1) return true;
    if (value === false || value === "no" || value === "0" || value === 0) return false;
    return null;
  }

  function readShopifyConsentState() {
    try {
      if (!window.Shopify || !Shopify.customerPrivacy || typeof Shopify.customerPrivacy.currentVisitorConsent !== "function") {
        return null;
      }

      var raw = Shopify.customerPrivacy.currentVisitorConsent() || {};
      return {
        performance: shopifyConsentValue(raw.analytics),
        functional: shopifyConsentValue(raw.preferences),
        targeting: shopifyConsentValue(raw.marketing)
      };
    } catch (err) {
      logConsentError("SHOPIFY_CONSENT_READ_FAILED", err);
      return null;
    }
  }

  // Checkout Reject All writes Shopify Privacy, not OptanonConsent.
  // If Shopify says no, treat that category as rejected for cookie cleanup.
  function getEffectiveConsentState() {
    var shopify = readShopifyConsentState();
    var performanceOK = isAllowed("C0002");
    var functionalOK = isAllowed("C0003");
    var targetingOK = isAllowed("C0004");

    if (shopify) {
      if (shopify.performance === false) performanceOK = false;
      if (shopify.functional === false) functionalOK = false;
      if (shopify.targeting === false) targetingOK = false;
    }

    return {
      performance: performanceOK,
      functional: functionalOK,
      targeting: targetingOK
    };
  }

  function syncShopifyConsent() {
    ensureCustomerPrivacyReady(function (ready) {
      if (!ready || !window.Shopify || !Shopify.customerPrivacy) {
        return;
      }

      var state = getEffectiveConsentState();

      Shopify.customerPrivacy.setTrackingConsent(
        {
          analytics: state.performance,
          preferences: state.functional,
          marketing: state.targeting,
          sale_of_data: state.targeting
        },
        function () {
          deleteShopifyBuiltInCookies(state);
        }
      );
    });
  }

  function loadScriptOnce(key, src, callback) {
    if (!src || window._ctl_loaded[key]) return;
    if (document.querySelector('script[data-ctl-key="' + key + '"]')) {
      window._ctl_loaded[key] = true;
      return;
    }

    var s = document.createElement("script");
    s.async = true;
    s.src = src;
    s.setAttribute("data-ctl-key", key);

    s.onload = function () {
      window._ctl_loaded[key] = true;
      if (typeof callback === "function") callback();
    };

    s.onerror = function (e) {
      window._ctl_loaded[key] = false;
      sentryCapture({
        level: "error",
        message: "[CookieConsent] Failed to load third-party script",
        tags: {
          area: "cookie-consent",
          vendor_key: key
        },
        extra: {
          script_src: src
        }
      });
    };

    document.head.appendChild(s);
  }

  function loadGA() {
    var settings = getSettings();
    if (!settings.ga_measurement_id) return;

    window["ga-disable-" + settings.ga_measurement_id] = false;

    loadScriptOnce("ga", "https://www.googletagmanager.com/gtag/js?id=" + settings.ga_measurement_id, function () {
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () {
        window.dataLayer.push(arguments);
      };

      window.gtag("js", new Date());
      window.gtag("config", settings.ga_measurement_id, { send_page_view: false });
    });
  }

  function disableGA() {
    var settings = getSettings();
    window._ctl_loaded.ga = false;

    if (settings.ga_measurement_id) {
      window["ga-disable-" + settings.ga_measurement_id] = true;
    }

    deleteCookiesByPrefixes(["_ga", "_gid", "_gat", "_gcl", "_gac"]);
  }
  function disableGoogleAdsFirstParty() {
    deleteNamedCookies(GOOGLE_TARGETING_COOKIE);
  }

  function loadHotjar() {
    var settings = getSettings();
    if (!settings.hotjar || !settings.hotjar_id || window._ctl_loaded.hotjar) return;

    window._ctl_loaded.hotjar = true;
    (function (h, o, t, j, a, r) {
      h.hj = h.hj || function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
      h._hjSettings = { hjid: settings.hotjar_id, hjsv: 6 };
      a = o.getElementsByTagName("head")[0];
      r = o.createElement("script");
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      r.setAttribute("data-ctl-key", "hotjar");
      a.appendChild(r);
    })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
  }

  function disableHotjar() {
    window._ctl_loaded.hotjar = false;
    deleteCookiesByPrefixes(["_hj"]);
    deleteLocalStorageKeys(PERFORMANCE_LOCAL_STORAGE_KEYS);
    deleteSessionStorageKeys(["hjViewportId"]);

    document.querySelectorAll('script[src*="hotjar"],script[data-ctl-key="hotjar"]').forEach(function (script) {
      script.remove();
    });
  }

  function deleteShopifyBuiltInCookies(consentState) {
    var performanceOK = consentState && typeof consentState.performance === "boolean"
      ? consentState.performance
      : isAllowed("C0002");
    var functionalOK = consentState && typeof consentState.functional === "boolean"
      ? consentState.functional
      : isAllowed("C0003");
    var targetingOK = consentState && typeof consentState.targeting === "boolean"
      ? consentState.targeting
      : isAllowed("C0004");

    // Shopify sets these before consent JS can block them; purge when categories are rejected.
    if (!performanceOK) {
      deleteNamedCookies(SHOPIFY_CONSENT_COOKIES.performance);
    }

    if (!functionalOK) {
      deleteNamedCookies(SHOPIFY_CONSENT_COOKIES.functional);
    }

    if (!targetingOK) {
      deleteNamedCookies(TARGETING_COOKIES);
      deleteNamedCookies(TARGETING_APP_COOKIES)
    }
  }

  function disableKlaviyoEmbed() {
    deleteNamedCookies(TARGETING_APP_COOKIES);
    deleteCookiesByPrefixes(["__kla"]);
    deleteLocalStorageKeys(TARGETING_LOCAL_STORAGE_KEYS);
    deleteLocalStorageByPrefixes(TARGETING_LOCAL_STORAGE_PREFIXES);
    deleteSessionStorageKeys(TARGETING_SESSION_STORAGE_KEYS);

    document.querySelectorAll('script[src*="klaviyo.com"],script[src*="klaviyo-onsite"]').forEach(function (script) {
      script.remove();
    });

    window._learnq = window._learnq || [];
    if (!window._learnq._ctl_stub) {
      var learnqStub = function () {
        learnqStub.q = learnqStub.q || [];
        learnqStub.q.push(arguments);
      };
      learnqStub._ctl_stub = true;
      window._learnq = learnqStub;
    }
  }

  function runAllStorageCleanup(consentState) {
    applyAppEmbedCookieConsent(consentState);
    applyLocalStorageConsent(consentState);
    applySessionStorageConsent(consentState);
    deleteShopifyBuiltInCookies(consentState);
  }

  function scheduleRejectStorageCleanup() {
    runAllStorageCleanup(REJECTED_CONSENT_STATE);
    schedulePostLoadLocalStorageCleanup(REJECTED_CONSENT_STATE);
    schedulePostLoadSessionStorageCleanup(REJECTED_CONSENT_STATE);
    applyInstantPrefetchConsent(false);

    window.setTimeout(function () {
      runAllStorageCleanup(REJECTED_CONSENT_STATE);
    }, 1500);
  }

  // Runs on first page load, every refresh, and every consent change.
  function applyAppEmbedCookieConsent(consentState) {
    var state = resolveConsentState(consentState || {});

    if (!state.targeting) {
      disableKlaviyoEmbed();
      disableGoogleAdsFirstParty();
    }
  }

  function runShopifyBuiltInCookieCleanupOnLoad() {
    ensureCustomerPrivacyReady(function () {
      applyConsent();
    });
  }

  function applyConsent() {
    var consentState = getEffectiveConsentState();
    var performanceOK = consentState.performance;
    var functionalOK = consentState.functional;
    var targetingOK = consentState.targeting;
    var groups = getGroups();

    // Sync Shopify Customer Privacy FIRST
    syncShopifyConsent();

    if (!groups) {
      logConsentIssue("GROUPS_EMPTY", "No OneTrust groups found while applying consent", {
        has_optanon_cookie: /(?:^|;\s*)OptanonConsent=/.test(document.cookie),
        onetrust_active_groups_type: typeof window.OnetrustActiveGroups
      });
    }

    if ((groups.indexOf("C0002") > -1 || groups.indexOf("C0003") > -1 || groups.indexOf("C0004") > -1) && !performanceOK && !functionalOK && !targetingOK) {
      logConsentIssue("GROUP_PARSE_MISMATCH", "Groups string contains categories but all consent checks resolved false", {
        groups: groups
      });
    }

    if (performanceOK) {
      loadGA();
      loadHotjar();
    } else {
      disableGA();
      disableHotjar();
    }

    var consentState = {
      performance: performanceOK,
      functional: functionalOK,
      targeting: targetingOK
    };

    deleteShopifyBuiltInCookies(consentState);
    applyAppEmbedCookieConsent(consentState);
    applyLocalStorageConsent(consentState);
    applySessionStorageConsent(consentState);
    schedulePostLoadLocalStorageCleanup(consentState);
    schedulePostLoadSessionStorageCleanup(consentState);
    applyInstantPrefetchConsent(functionalOK);
  }

  window.applyCookieConsent = applyConsent;
  window.isConsentGroupAllowed = isConsentGroupAllowed;
  window.applyLocalStorageConsent = applyLocalStorageConsent;
  window.applySessionStorageConsent = applySessionStorageConsent;
  window.applyAppEmbedCookieConsent = applyAppEmbedCookieConsent;
  window.deleteShopifyBuiltInCookies = deleteShopifyBuiltInCookies;
  window.deleteTargetingLocalStorage = deleteTargetingLocalStorage;

  try {
    installPrefetchGuard();
    applyConsent();
  } catch (err) {
    logConsentError("INITIAL_APPLY_FAILED", err, {
      phase: "initial_load"
    });
  }

  if (document.readyState === "complete") {
    runShopifyBuiltInCookieCleanupOnLoad();
  } else {
    window.addEventListener("load", runShopifyBuiltInCookieCleanupOnLoad);
  }

  window.addEventListener("OneTrustGroupsUpdated", function () {
    try {
      applyConsent();

      if (!isAllowed("C0002") && !isAllowed("C0003") && !isAllowed("C0004")) {
        scheduleRejectStorageCleanup();
      }
    } catch (err) {
      logConsentError("GROUPS_UPDATED_HANDLER_FAILED", err, {
        event: "OneTrustGroupsUpdated"
      });
    }
  });

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target) return;

    if (
      target.closest(".onetrust-accept-btn-handler") ||
      target.closest(".onetrust-reject-all-handler") ||
      target.closest("#onetrust-accept-btn-handler") ||
      target.closest("#onetrust-reject-all-handler") ||
      target.closest(".ot-pc-refuse-all-handler") ||
      target.closest(".ot-pc-accept-all-handler") ||
      target.closest("#onetrust-pc-btn-handler") ||
      target.closest(".save-preference-btn-handler") ||
      target.closest("#accept-recommended-btn-handler")
    ) {
      var action = target.closest(".onetrust-reject-all-handler") ||
        target.closest("#onetrust-reject-all-handler") ||
        target.closest(".ot-pc-refuse-all-handler")
        ? "reject_all"
        : "accept_all";
      setTimeout(function () {
        try {
          applyConsent();

          if (action === "reject_all") {
            scheduleRejectStorageCleanup();
          }

          var snapshot = getConsentSnapshot();
          if (action === "accept_all" && !snapshot.performance && !snapshot.functional && !snapshot.targeting) {
            logConsentIssue("ACCEPT_ALL_NO_GROUP_ENABLED", "Accept all clicked but no non-essential groups are enabled", snapshot);
          }
          if (action === "reject_all" && (snapshot.performance || snapshot.functional || snapshot.targeting)) {
            logConsentIssue("REJECT_ALL_GROUP_STILL_ENABLED", "Reject all clicked but one or more non-essential groups remain enabled", snapshot);
          }
        } catch (err) {
          logConsentError("BANNER_CLICK_APPLY_FAILED", err, {
            action: action
          });
        }
      }, 300);
    }
  });
})();